export const bannerType = {
  big: 'big',
  small: 'small',
  routes: 'routes'
};
